<template>
  <div
    class="publicity"
    :class="{
      'home-style': styleModel === 'home-style',
      'notice-style': styleModel === 'notice-style',
      'analysis-style': styleModel === 'analysis-style'
    }"
  >
    <div class="title">
      <img
        v-if="page != 'HomeView'"
        style="height: 22.63px"
        :src="require('@/assets/images/treasure-chest/left-icon.png')"
      />
      <div class="m-l-16 m-r-16">更多功能推荐</div>
      <img
        v-if="page != 'HomeView'"
        style="height: 22.63px"
        :src="require('@/assets/images/treasure-chest/right-icon.png')"
      />
    </div>
    <div class="item-content">
      <div class="item-box">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="item"
          :class="{ 'function-item': item.type === 'more' }"
        >
          <div class="item-title">
            {{ item.title }}
          </div>
          <div class="item-text">
            {{ item.text }}
          </div>
          <div class="item-btn-box">
            <div class="item-btn open-btn" @click="handleVipBuy">
              {{ item.openBtn }}
            </div>
            <div
              v-if="item.detailBtn"
              class="item-btn detail-btn"
              @click="goPage(item.roterName)"
            >
              {{ item.detailBtn }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toVipBuy } from '@/utils/common'

export default {
  name: 'MembersPublicity',

  props: {
    styleModel: {
      type: String,
      default: 'home-style',
      require: true
    },
    page: {
      type: String,
      default: 'home',
      require: true
    }
  },

  data() {
    return {
      list: [
        {
          title: '全网商机',
          text: '获取全国各行业最新招标信息，每日1W+实时更新，助力业绩规模化增长。',
          openBtn: '开通会员',
          detailBtn: '了解详情',
          roterName: 'ServiceIntroductionBigDataBusiness'
        },
        {
          title: '投标顾问',
          text: '针对本平台内发布的项目，专业顾问全程一对一辅导，代办投标流程相关事宜，投标效率显著提升。',
          openBtn: '开通会员',
          detailBtn: '了解更多',
          roterName: 'ServiceIntroductionBidConsultant'
        },
        {
          title: '标书预览',
          text: '优先精准掌握标书关键参数，洞悉评标法则，远离盲目购买标书而损失的各项成本，让投标更主动高效。',
          openBtn: '开通会员',
          detailBtn: '了解详情',
          roterName: 'ServiceIntroductionDocumentPreview'
        },
        {
          title: '标讯订阅',
          text: '支持按地区、行业、关键词（可设置300组）订阅，自动获取精准商机。',
          openBtn: '开通会员',
          detailBtn: '了解详情',
          roterName: 'ServiceIntroductionBigDataBusiness'
        },
        {
          title: '数据定制导出',
          text: '以项目为核心，支持excel批量导出招标数据，精细化分析数据，构建新人脉，寻找新机会。',
          openBtn: '开通会员',
          detailBtn: '了解详情',
          roterName: 'ServiceIntroductionBigDataBusiness'
        },
        {
          title: '会员保证金担保',
          text: '无需缴纳投标保证金，投标更高效，资金周转零压力。',
          openBtn: '开通会员',
          detailBtn: '了解更多',
          roterName: 'ServiceIntroductionBond'
        },
        {
          title: '竞争对手分析',
          text: '全方位、多维度展示竞争对手历史业绩，助您第一时间了解对手，挖掘重要合作客户关系。',
          openBtn: '开通会员',
          detailBtn: '了解详情',
          roterName: 'ServiceIntroductionCompetitiveness'
        },
        {
          title: '采购单位分析',
          text: '分析采购单位招标需求，重点项目联系人，采购规模走势，重点采购行业，帮助企业拓客。',
          openBtn: '开通会员',
          detailBtn: '了解详情',
          roterName: 'ServiceIntroductionCompetitiveness'
        },
        {
          title: '了解会员套餐完整清单',
          text: '全方位满足企业需求',
          openBtn: '开通会员',
          type: 'more'
        }
      ]
    }
  },

  methods: {
    goPage(name) {
      if (name != this.page) {
        this.$router.push({
          name: name
        })
      }
    },
    handleVipBuy() {
      toVipBuy(this.$router)
    }
  }
}
</script>

<style lang="scss" scoped>
.publicity {
  width: 100%;
  background: $white-color;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    color: $text-color;
    padding-top: 80px;
  }

  .item-content {
    display: flex;
    justify-content: center;
  }
  .item-box {
    display: flex;
    width: 1221px;
    flex-wrap: wrap;
    margin-top: 30px;
    margin-bottom: 70px;
    .item {
      border: 1px solid $info-fourth-color;
      box-sizing: border-box;
      border-radius: 4px;
      width: 387px;
      height: 180px;
      margin: 10px;
      cursor: pointer;
      padding: 24px;
      .item-title {
        color: $text-color;
        font-size: 16px;
        @include text-bold;
      }
      .item-text {
        line-height: 22px;
        color: $text-second-color;
        font-size: 14px;
        margin-top: 12px;
        margin-bottom: 24px;
        height: 44px;
      }
      .item-btn-box {
        display: flex;
        .item-btn {
          width: 96px;
          height: 32px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          box-sizing: border-box;
        }
      }
      &:hover {
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.14);
      }
    }

    .function-item {
      border: 0;
      background: url('~@/assets/images/function-bg.png') no-repeat;
      background-size: 100%;
      border-radius: 0;
    }
  }
}
.home-style {
  background: $white-color;

  .open-btn {
    color: $white-color;
    background: $primary-color;

    &:hover {
      background: $primary-hover-color;
    }
  }
  .detail-btn {
    color: $text-color;
    border: 1px solid $info-third-color;
    margin-left: 12px;

    &:hover {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
}
.notice-style {
  background: $white-color;
  .click-text {
    cursor: pointer;
    color: $member-color;
  }
  .open-btn {
    color: $member-second-color !important;
    background: $member-sixth-color;
  }
  .detail-btn {
    color: $text-color;
    border: 1px solid $info-third-color;
    margin-left: 12px;
  }
}
.analysis-style {
  background: url('~@/assets/images/treasure-chest/subscription/bg3.png')
    no-repeat;
  background-size: cover;

  .item {
    background: $white-color;
    .open-btn {
      color: $member-second-color;
      background: $member-sixth-color;
    }
    .detail-btn {
      color: $text-color;
      border: 1px solid $info-third-color;
      margin-left: 12px;
    }
  }
}
</style>
